export default {"src":"/login-app/[GIT_HASH]/_next/static/media/and.f830f699.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};